import { useQuery } from '@tanstack/react-query';

export const fetchPricesAPI = () =>
    useQuery({
        queryKey: ['prices'],
        queryFn: async () => {
            const response = await fetch(`${import.meta.env.VITE_API_URL}/prices`);
            if (!response.ok) {
                throw new Error('Error making API call');
            }
            const data = await response.json();
            return data;
        },
    });